import SiteHeader from "@/pages/home/components/SiteHeader";
import HeroSection from "@/pages/home/components/HeroSection";
import EntryGrid from "@/pages/home/components/EntryGrid";
import FlashNews from "@/pages/home/components/FlashNews";
import CaseGrid from "@/pages/home/components/CaseGrid";
import TimelineSection from "@/pages/home/components/TimelineSection";
import FileSection from "@/pages/home/components/FileSection";
import CommentSection from "@/pages/home/components/CommentSection";
import TagSection from "@/pages/home/components/TagSection";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="w-full flex-1">
        <HeroSection />
        <EntryGrid />
        <FlashNews />
        <CaseGrid />
        <TimelineSection />
        <FileSection />
        <CommentSection />
        <TagSection />
      </main>
      <SiteFooter />
    </div>
  );
}